import { CONTACT_NAME, CONTACT_COMPANY, CONTACT_WHATSAPP } from '../lib/config';
import { useI18n } from '../lib/i18n';

// WhatsApp brand glyph (inline so it needs no external asset / survives rasterisation).
function WhatsAppIcon({ className = 'w-4 h-4' }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.51 5.26l-.999 3.648 3.978-1.615zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.767.967-.94 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" />
    </svg>
  );
}

// International-format the digits-only WhatsApp number: 972549573533 -> +972 54 957 3533.
function waDisplay() {
  const d = CONTACT_WHATSAPP;
  const m = d.match(/^(\d{3})(\d{2})(\d{3})(\d{4})$/);
  return '+' + (m ? `${m[1]} ${m[2]} ${m[3]} ${m[4]}` : d);
}

// Signature footer shared by both PDF formats (A4 + Mobile). Lives inside the
// captured DOM node so it is baked into every export.
// When `fixedRate` is a number, a manual AED→ILS rate was fixed at share time — print
// that instead of the usual "indicative conversion" line so the client knows the ₪
// figures are pinned to a specific rate rather than a live one.
export default function ReportFooter({ className = '', fixedRate = null }) {
  const { t } = useI18n();
  const hasFixed = fixedRate != null && Number(fixedRate) > 0;
  return (
    <div className={`mt-6 rounded-[1.75rem] border border-black/[0.06] bg-white px-5 py-5 text-center ${className}`}>
      <p className="text-sm text-gray-600">
        {t('prepared_by')} <span className="font-semibold text-gray-800">{CONTACT_NAME}</span> — {CONTACT_COMPANY}
      </p>
      <div className="mt-2 inline-flex items-center gap-2 rounded-xl bg-primary text-white px-4 py-2 text-sm font-semibold">
        <WhatsAppIcon /> WhatsApp <span dir="ltr" className="tabular-nums">{waDisplay()}</span>
      </div>
      <p className="mt-3 text-[11px] text-gray-400 max-w-md mx-auto leading-snug">
        {t('footer_disclaimer')}
        {hasFixed
          ? t('footer_rate_fixed', { x: Number(fixedRate).toFixed(4) })
          : t('footer_rate_indicative')}
      </p>
    </div>
  );
}
